module.exports = __webpack_public_path__ + "img/gjdSet.fdbcb06e.jpg";